/* eslint-disable */
import React, { PureComponent, Suspense } from "react";
import {
  WebConfigDataContextProvider,
  ConstraintsContextProvider,
  TransContextProvider,
  FixturesContextProvider,
  CompositionContextProvider,
  PlayerListContextProvider,
  TeamListContextProvider,
  TeamDataContextProvider,
  PlayerRecomendationContextProvider,
  LoginContextProvider,
  GamedaysProvider,
  PlayerCardContextProvider,
  LiveScoringContextProvider,
  LeaguesContextProvider,
  FetchGamerCardProvider,
  FetchGeoLocationUrlProvider,
  PlayersStatisticsProvider,
  BoosterCardContextProvider,
  GamerCardProvider,
  MixApiProvider,
} from "./Context/Providers";
import Main from "./components/Main";
import Routes from "./components/Routes";
import config from "./common/config";
import {
  hideLoader,
  makeClasses,
  detectAdBlocker,
  getLoginCookie,
  clearLocalStorage,
  getData,
} from "./common";

class Game extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isAdDetectcodeloaded: false,
      isAdBlocked: false,
      goAhead: false,
    };
  }

  setAdsFlag = (flag, isAdBlocked) => {
    let self = this;
    config.isAdBlocked = isAdBlocked;
    self.setState({
      isAdDetectcodeloaded: flag,
      isAdBlocked: isAdBlocked,
    });
  };

  avoidConsoles = () => {
    let method;
    const noop = function () {};
    const methods = [
      "assert",
      "clear",
      "count",
      "debug",
      "dir",
      "dirxml",
      "error",
      "exception",
      "group",
      "groupCollapsed",
      "groupEnd",
      "info",
      "log",
      "markTimeline",
      "profile",
      "profileEnd",
      "table",
      "time",
      "timeEnd",
      "timeStamp",
      "trace",
      "warn",
    ];
    let length = methods.length;
    const console = (window.console = window.console || {});
    while (length--) {
      method = methods[length];
      // Only stub undefined methods.
      if (console[method]) {
        console[method] = noop;
      }
    }
  };

  componentDidMount() {
    let self = this;
    let loginCookie = getLoginCookie();
    if (loginCookie && loginCookie.IsRegistered !== 1) {
      let apiParams = {
        endPoint: config.LOGINAPIBASEPATH + "logout",
        type: "POST",
        name: "Logout",
        params: {},
      };
      getData(
        apiParams,
        (resp) => {
          clearLocalStorage();
          self.setState({
            goAhead: true,
          });
        },
        (error) => {
          if (err) {
            err(error);
          }
        }
      );
    } else {
      self.setState({
        goAhead: true,
      });
    }
    //comment console's
    //call gtm tag
    //call ads code

    //end
    detectAdBlocker(this.setAdsFlag);
    // if (window.OptanonActiveGroups && window.OnetrustActiveGroups) {
    //   pushOptanonEvents();

    //   // Send OneTrust events
    //   function pushOptanonEvents() {
    //     window.dataLayer = window.dataLayer || [];
    //     window.dataLayer.push(
    //       { event: 'OptanonLoaded', "OptanonActiveGroups": OptanonActiveGroups },
    //       { event: 'OneTrustLoaded', "OnetrustActiveGroups": OnetrustActiveGroups });
    //   }
    // }

    hideLoader();
    if (config.showConsole == "0") {
      this.avoidConsoles();
    }

    window[config.namespaceKey] = {
      onLoad: true,
      trans: [["key", "value"]],
      printFiles: (obj) => {
        if (config.printExcel) {
          // var worksheet = XLSX.utils.aoa_to_sheet(obj);
          // var new_workbook = XLSX.utils.book_new();
          // XLSX.utils.book_append_sheet(new_workbook, worksheet, "SheetJS");
          // XLSX.writeFile(new_workbook, 'translations.xlsb');
        }
      },
    };
  }

  //config api call no config setup at local
  //
  render() {
    let self = this;
    let mainPitchClass = makeClasses({
      "si-main-component": true,
      "si-bg--pitch": false,
    });

    return self.state.goAhead ? (
      <WebConfigDataContextProvider>
        <FetchGeoLocationUrlProvider>
          <MixApiProvider>
            <LoginContextProvider>
              <ConstraintsContextProvider>
                <TransContextProvider>
                  <FixturesContextProvider>
                    <CompositionContextProvider>
                      <PlayerListContextProvider>
                        <GamedaysProvider>
                          <TeamDataContextProvider>
                            <LiveScoringContextProvider>
                              <PlayerCardContextProvider>
                                <BoosterCardContextProvider>
                                  <LeaguesContextProvider>
                                    <PlayersStatisticsProvider>
                                      <GamerCardProvider>
                                        <Main />
                                        <div
                                          id="loaderWrap"
                                          style={{ display: "none" }}
                                          className="si-loader__wrap si-center"
                                        >
                                          <div className="si-loader"></div>
                                        </div>
                                      </GamerCardProvider>
                                    </PlayersStatisticsProvider>
                                  </LeaguesContextProvider>
                                </BoosterCardContextProvider>
                              </PlayerCardContextProvider>
                            </LiveScoringContextProvider>
                          </TeamDataContextProvider>
                        </GamedaysProvider>
                      </PlayerListContextProvider>
                    </CompositionContextProvider>
                  </FixturesContextProvider>
                </TransContextProvider>
              </ConstraintsContextProvider>
            </LoginContextProvider>
          </MixApiProvider>
        </FetchGeoLocationUrlProvider>
      </WebConfigDataContextProvider>
    ) : null;
  }
}

export default Game;
